import useResizeObserver from "@react-hook/resize-observer";
import { useLayoutEffect, useRef, useState } from "react";

export const useElementSize = (
    target: React.RefObject<HTMLDivElement> | HTMLElement,
    debounceMs = 0 // default no debounce if 0
) => {
    const [size, setSize] = useState<DOMRect>();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useLayoutEffect(() => {
        const element = "current" in target ? target.current : target;
        setSize(element?.getBoundingClientRect());
    }, [target]);

    useResizeObserver(target, (entry) => {
        if (debounceMs === 0) {
            // No debounce, update immediately
            setSize(entry.contentRect);
            return;
        }

        // Clear previous timer
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Set new timer to update after debounce delay
        timeoutRef.current = setTimeout(() => {
            setSize(entry.contentRect);
        }, debounceMs);
    });

    return size;
};
